import { render, staticRenderFns } from "./myOrganisationSites.vue?vue&type=template&id=2305c0bf&"
import script from "./myOrganisationSites.vue?vue&type=script&lang=js&"
export * from "./myOrganisationSites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports